
var sprite = require("D:/a/1/s/Web/CMS/App_Themes/Safestore/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 24.018 23.502\" id=\"icon-cross\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"> <path d=\"M14.753,12.177l8.428,8.428l-2.897,2.897l-8.428-8.427L3.621,23.31l-2.913-2.914l8.234-8.234L0,3.219\r\n\tl2.896-2.897l8.943,8.943L21.104,0l2.914,2.913L14.753,12.177z\"/> </symbol>";
module.exports = sprite.add(image, "icon-cross");


/*****************
 ** WEBPACK FOOTER
 ** ./svg/src/cross.svg
 ** module id = 164
 ** module chunks = 24
 **/